export default __webpack_public_path__ + "static/woman-0f49858f2d6811edaa6182ffe7028bfa.svg";